<div class="home-container">
    <div class="pull-refresh-bar" [style.height.px]="pullDistance" [class.ready]="readyToRefresh" [class.snapping]="isSnapping">
        <span class="material-symbols-rounded ptr-icon">{{ readyToRefresh ? 'refresh' : 'arrow_downward' }}</span>
    </div>

    <header>
        <div class="user-greeting">
            <p class="subtitle">Bom dia<span *ngIf="greetingName">, {{ greetingName }}</span></p>
            <h1 class="page-title">Aprovação OS</h1>
            <p class="filial-name" *ngIf="filialName">{{ filialName }}</p>
            <div class="panel-tabs">
                <button type="button" class="panel-tab-btn" (click)="backCreateOs()">
                    <span class="material-symbols-rounded">sync_alt</span>
                    Painel Criação OS
                </button>
                <button type="button" class="panel-tab-btn active" disabled>
                    <span class="material-symbols-rounded">check_circle</span>
                    Painel Aprovação OS
                </button>
            </div>
        </div>
            
            <div class="user-avatar avatar" (click)="toggleMenu()" style="cursor: pointer; position: relative;">
                <span class="material-symbols-rounded">person</span>
    
                <div class="menu-overlay" *ngIf="isMenuOpen" (click)="closeMenu(); $event.stopPropagation()"></div>
                <div class="menu-wrapper" *ngIf="isMenuOpen">
                    <app-profile-menu (close)="closeMenu()"></app-profile-menu>
                </div>
            </div>
    </header>

    <section class="search-section">
        <div class="input-group">
            <span class="material-symbols-rounded input-icon">search</span>
            <input type="text" [formControl]="searchControl" (keydown.enter)="submitSearch()"
                placeholder="Buscar placa, cliente ou OS #...">
            <button type="button" class="qr-code-btn btn-icon-only" (click)="submitSearch()">
                <span class="material-symbols-rounded search-spinner" [class.spinning]="isSearching">search</span>
            </button>
        </div>
    </section>

    <section class="list-section">
        <div class="section-header">
            <h2 class="section-title">Ordens de Serviço para Aprovação</h2>
            <div class="tabs" *ngIf="!hasActiveSearch">
                <button type="button" class="tab-btn" [class.active]="activeTab === 'pendentes'"
                    (click)="setActiveTab('pendentes')">
                    Pendentes
                </button>
            </div>
            <!-- <div class="tabs" *ngIf="hasActiveSearch">
                <button type="button" class="tab-btn" *ngFor="let status of statusFilters"
                    [class.active]="activeStatusFilter === status" (click)="setStatusFilter(status)">
                    {{ status }}
                </button>
            </div> -->
        </div>

        <div class="list-feedback"
            *ngIf="isSearchPending || isLoadingOrders || loadOrdersError || (!(isSearchPending || isLoadingOrders) && !loadOrdersError && filteredOrders.length === 0)">
            <app-loader *ngIf="isSearchPending || isLoadingOrders" message="Carregando ordens de serviço..."></app-loader>
            <p class="helper-text error-text" *ngIf="!(isSearchPending || isLoadingOrders) && loadOrdersError">{{ loadOrdersError }}</p>
            <div class="empty-all-good" *ngIf="!(isSearchPending || isLoadingOrders) && !loadOrdersError && filteredOrders.length === 0">
                <span class="material-symbols-rounded check-icon">check_circle</span>
                <span class="status-text">TUDO EM DIA</span>
            </div>
        </div>

        <div class="detail-content" *ngIf="!isSearchPending && !isLoadingOrders && !loadOrdersError">
            <div class="order-list">
                <div *ngFor="let order of filteredOrders">
                    <app-os-approval-card [order]="order"
                        (approvalRejectOs)="onApprovalRejectOs($event)"></app-os-approval-card>
                </div>
            </div>
        </div>

    </section>

    <div class="status-footer">
        <app-loader *ngIf="isLoadingMore" size="sm" message="Carregando mais ordens..."></app-loader>
        <div class="status-all-good" *ngIf="filteredOrders.length > 0 && !isLoadingOrders && !isLoadingMore && !loadOrdersError && !hasNextPage">
            <span class="material-symbols-rounded check-icon">check_circle</span>
            <span class="status-text">TUDO EM DIA</span>
        </div>
    </div>

    <div class="toast" *ngIf="toast" [class.toast--leaving]="toastLeaving" [class.toast--reject]="toast.variant === 'reject'">
        <span class="material-symbols-rounded toast__icon">{{ toast.icon }}</span>
        <span class="toast__message">{{ toast.message }}</span>
    </div>
</div>
